import { AxiosResponse } from 'axios'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { $axios } from './axios'
import { EmailContentType } from '../../server/models/EmailContent'

export const getEmailContent = (
  inboxId: string,
  emailId: string
): Promise<AxiosResponse<EmailContentType>> => {
  return $axios.get(`/inboxes/${inboxId}/emails/${emailId}/content`)
}

export const useEmailContentQuery = (
  inboxId: string,
  emailId: string,
  options?: Omit<UseQueryOptions<EmailContentType, Error>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<EmailContentType, Error>({
    queryKey: ['sourceContent', inboxId, emailId],
    queryFn: async () => {
      const res = await getEmailContent(inboxId, emailId)
      return res.data
    },
    staleTime: 10 * 60 * 1000, // 10 minutes - liberal caching
    gcTime: 60 * 60 * 1000, // 1 hour - keep in cache for a long time
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    ...options
  })
}
